module.exports = __webpack_public_path__ + "static/media/scania.0b0850e7.svg";